/**
 * Header menu panel
 *
 * @package EBNewsletters
 */

const NAV = {
	toggle: '[data-nav-toggle]',
	overlay: '.nav-overlay',
	open: 'is-open',
};

const initHeader = () => {
	const button = document.querySelector(NAV.toggle);
	const panel =
		button && document.getElementById(button.getAttribute('aria-controls'));
	if (!panel) {
		return;
	}

	const overlay = document.querySelector(NAV.overlay);

	const setOpen = open => {
		button.setAttribute('aria-expanded', String(open));
		panel.classList.toggle(NAV.open, open);
		overlay?.classList.toggle(NAV.open, open);
		panel.inert = !open;
	};

	setOpen(false);

	button.addEventListener('click', () =>
		setOpen(button.getAttribute('aria-expanded') !== 'true')
	);

	overlay?.addEventListener('click', () => setOpen(false));
};

export default initHeader;
